{
  "level": "sub01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:sub01",
    "objects": "AREAS.E3:sub01.e3",
    "mesh": "TREES.E3:sub01.e3"
  },
  "spawn_point": {
    "position": [
      1665.3935112322952,
      85.42908043709777,
      -355.6484069824219
    ],
    "facing_rad": 0.0,
    "look_point": [
      1665.3935112322952,
      185.42908043709775,
      -355.6484069824219
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -1709.6956787109375,
      -94.099853515625,
      -379.6484069824219
    ],
    "bbox_max": [
      2393.048828125,
      600.0,
      -60.99939727783203
    ],
    "vertex_count": 401,
    "vertices": [
      [
        2366.01318359375,
        565.6466064453125,
        -109.64839935302734
      ],
      [
        2380.913818359375,
        577.2862548828125,
        -99.62260437011719
      ],
      [
        2380.913818359375,
        577.2861938476562,
        -99.62260437011719
      ],
      [
        2393.048828125,
        596.0772705078125,
        -83.62440490722656
      ],
      [
        2393.048828125,
        596.0772705078125,
        -83.62440490722656
      ],
      [
        2392.63818359375,
        600.0,
        -80.33102416992188
      ],
      [
        2330.657958984375,
        363.2314147949219,
        -83.62440490722656
      ],
      [
        2325.47216796875,
        370.37506103515625,
        -67.6260986328125
      ],
      [
        2325.47216796875,
        370.37506103515625,
        -67.6260986328125
      ],
      [
        2309.36865234375,
        373.72052001953125,
        -60.99939727783203
      ],
      [
        2309.36865234375,
        373.72052001953125,
        -60.99939727783203
      ],
      [
        2291.62353515625,
        371.31243896484375,
        -67.6260986328125
      ],
      [
        2321.74853515625,
        356.4781494140625,
        -99.62260437011719
      ],
      [
        2330.657958984375,
        363.2314147949219,
        -83.62440490722656
      ],
      [
        2308.88671875,
        352.44757080078125,
        -109.64839935302734
      ],
      [
        2321.74853515625,
        356.4781494140625,
        -99.62260437011719
      ],
      [
        -1532.589599609375,
        310.900146484375,
        -320.4476318359375
      ],
      [
        -1621.3636474609375,
        318.0,
        -317.756591796875
      ],
      [
        1431.6453857421875,
        -52.900146484375,
        -308.0058898925781
      ],
      [
        1784.12109375,
        -60.190975189208984,
        -225.87344360351562
      ],
      [
        1820.640625,
        -48.5523681640625,
        -216.42996215820312
      ],
      [
        1793.3388671875,
        -44.98992919921875,
        -218.7095184326172
      ],
      [
        1793.3388671875,
        -44.98993682861328,
        -218.7095184326172
      ],
      [
        1769.311279296875,
        -37.86620330810547,
        -229.70309448242188
      ],
      [
        1762.6708984375,
        -36.107540130615234,
        -232.2679443359375
      ],
      [
        1769.311279296875,
        -37.86619567871094,
        -229.70309448242188
      ],
      [
        1762.6708984375,
        -36.107540130615234,
        -232.2679443359375
      ],
      [
        1762.652099609375,
        -35.891876220703125,
        -232.74993896484375
      ],
      [
        1762.55517578125,
        -34.78263854980469,
        -235.22901916503906
      ],
      [
        1762.640625,
        -31.938758850097656,
        -241.6551513671875
      ],
      [
        1762.55517578125,
        -34.78263854980469,
        -235.22901916503906
      ],
      [
        1818.2681884765625,
        -55.31013107299805,
        -220.0818328857422
      ],
      [
        1836.7735595703125,
        -50.351646423339844,
        -215.77200317382812
      ],
      [
        1820.640625,
        -48.552371978759766,
        -216.42996215820312
      ],
      [
        1784.12109375,
        -60.19097900390625,
        -225.87344360351562
      ],
      [
        1836.7735595703125,
        -50.351646423339844,
        -215.77200317382812
      ],
      [
        1818.2681884765625,
        -55.31013107299805,
        -220.0818328857422
      ],
      [
        1840.805419921875,
        -50.18458557128906,
        -216.9972686767578
      ],
      [
        1431.0350341796875,
        -94.099853515625,
        -324.1415100097656
      ],
      [
        1431.0350341796875,
        -94.099853515625,
        -324.1415100097656
      ],
      [
        1616.8890380859375,
        -87.0,
        -298.3226013183594
      ],
      [
        1617.1142578125,
        -45.900146484375,
        -282.273681640625
      ],
      [
        1431.6453857421875,
        -52.900146484375,
        -308.0058898925781
      ],
      [
        1762.72607421875,
        -29.092750549316406,
        -248.08612060546875
      ],
      [
        1769.244873046875,
        -28.830841064453125,
        -250.0486602783203
      ],
      [
        1769.244873046875,
        -28.83083724975586,
        -250.04867553710938
      ],
      [
        1784.983642578125,
        -28.287120819091797,
        -254.58726501464844
      ],
      [
        1734.06103515625,
        -41.486328125,
        -266.0483093261719
      ],
      [
        1762.72607421875,
        -29.092744827270508,
        -248.08612060546875
      ],
      [
        1848.431640625,
        -50.264427185058594,
        -220.25286865234375
      ],
      [
        1850.3526611328125,
        -49.78899383544922,
        -219.8986053466797
      ],
      [
        1828.864990234375,
        -52.900142669677734,
        -218.63150024414062
      ],
      [
        1852.6746826171875,
        -49.70515441894531,
        -220.57640075683594
      ],
      [
        1850.3526611328125,
        -49.789005279541016,
        -219.8986053466797
      ],
      [
        1848.431640625,
        -50.26443862915039,
        -220.25286865234375
      ],
      [
        1867.327880859375,
        -42.16461944580078,
        -240.65249633789062
      ],
      [
        1867.327880859375,
        -45.80594253540039,
        -232.4474334716797
      ],
      [
        1867.70947265625,
        -49.162235260009766,
        -224.96495056152344
      ],
      [
        1867.3280029296875,
        -49.17601013183594,
        -224.85360717773438
      ],
      [
        1867.70947265625,
        -49.16223907470703,
        -224.96495056152344
      ],
      [
        1867.327880859375,
        -45.80595016479492,
        -232.4474334716797
      ],
      [
        1816.9920654296875,
        -55.4925422668457,
        -220.29827880859375
      ],
      [
        1832.5479736328125,
        -44.24842071533203,
        -254.90972900390625
      ],
      [
        1858.846435546875,
        -38.1037712097168,
        -248.01731872558594
      ],
      [
        1867.327880859375,
        -42.16461944580078,
        -240.65249633789062
      ],
      [
        1700.0,
        -80.23661041259766,
        -285.37799072265625
      ],
      [
        1700.0,
        -80.23661041259766,
        -285.37799072265625
      ],
      [
        1616.8890380859375,
        -87.0,
        -298.3226013183594
      ],
      [
        1700.0,
        -50.31498336791992,
        -273.7143249511719
      ],
      [
        1617.1143798828125,
        -45.900146484375,
        -282.273681640625
      ],
      [
        1700.0,
        -50.31498336791992,
        -273.7143249511719
      ],
      [
        1858.846435546875,
        -38.10376739501953,
        -248.01731872558594
      ],
      [
        1832.5479736328125,
        -44.2484130859375,
        -254.90972900390625
      ],
      [
        1857.271240234375,
        -37.43697738647461,
        -249.18817138671875
      ],
      [
        -1684.244873046875,
        352.099853515625,
        -304.5184326171875
      ],
      [
        -1621.4713134765625,
        359.099853515625,
        -301.7356872558594
      ],
      [
        -1621.3636474609375,
        318.0,
        -317.756591796875
      ],
      [
        -1690.517822265625,
        329.78173828125,
        -313.2236022949219
      ],
      [
        -1709.695556640625,
        340.181640625,
        -309.1861572265625
      ],
      [
        -1684.2449951171875,
        352.099853515625,
        -304.5184326171875
      ],
      [
        -1690.517822265625,
        329.78173828125,
        -313.2236022949219
      ],
      [
        -1709.6956787109375,
        340.181640625,
        -309.1861572265625
      ],
      [
        2012.3603515625,
        30.796566009521484,
        -171.07891845703125
      ],
      [
        1798.99658203125,
        -45.72816848754883,
        -218.23712158203125
      ],
      [
        2012.3603515625,
        30.79656410217285,
        -171.07891845703125
      ],
      [
        1948.7330322265625,
        19.138996124267578,
        -198.33261108398438
      ],
      [
        1988.2633056640625,
        -9.760089874267578,
        -180.4905548095703
      ],
      [
        1948.7330322265625,
        19.138999938964844,
        -198.33261108398438
      ],
      [
        1928.3612060546875,
        15.289064407348633,
        -207.0555877685547
      ],
      [
        1928.3612060546875,
        15.2890625,
        -207.05560302734375
      ],
      [
        1876.6849365234375,
        -2.346170425415039,
        -228.984619140625
      ],
      [
        1988.263427734375,
        -9.760066986083984,
        -180.4905242919922
      ],
      [
        1929.9735107421875,
        -30.083520889282227,
        -205.2152099609375
      ],
      [
        1902.085205078125,
        -39.951297760009766,
        -217.04086303710938
      ],
      [
        1929.9735107421875,
        -30.083524703979492,
        -205.2152099609375
      ],
      [
        1902.085205078125,
        -39.95130157470703,
        -217.04086303710938
      ],
      [
        1867.698974609375,
        -49.07025146484375,
        -225.17002868652344
      ],
      [
        1901.2532958984375,
        -40.097171783447266,
        -217.3973846435547
      ],
      [
        1876.6849365234375,
        -2.3461685180664062,
        -228.98463439941406
      ],
      [
        1851.7620849609375,
        -10.978059768676758,
        -239.55760192871094
      ],
      [
        1867.3546142578125,
        -46.04069900512695,
        -231.92408752441406
      ],
      [
        2300.03662109375,
        253.5687255859375,
        -80.83638000488281
      ],
      [
        2285.625,
        238.04981994628906,
        -88.67321014404297
      ],
      [
        2278.818603515625,
        230.66043090820312,
        -92.39784240722656
      ],
      [
        2285.625,
        238.04981994628906,
        -88.67321014404297
      ],
      [
        2278.818603515625,
        230.66043090820312,
        -92.39784240722656
      ],
      [
        2054.806396484375,
        6.951873779296875,
        -180.9961700439453
      ],
      [
        2278.40234375,
        230.27223205566406,
        -92.60077667236328
      ],
      [
        2046.9388427734375,
        -0.9157280921936035,
        -184.1249542236328
      ],
      [
        2054.806396484375,
        6.951882839202881,
        -180.9961700439453
      ],
      [
        2046.9388427734375,
        -0.9157277941703796,
        -184.1249542236328
      ],
      [
        2046.9158935546875,
        -0.9288614392280579,
        -184.11534118652344
      ],
      [
        2046.2012939453125,
        -1.3181374073028564,
        -183.78091430664062
      ],
      [
        2046.206298828125,
        -1.3341633081436157,
        -183.81887817382812
      ],
      [
        2046.2012939453125,
        -1.3181381225585938,
        -183.78091430664062
      ],
      [
        2046.206298828125,
        -1.3341636657714844,
        -183.81887817382812
      ],
      [
        1973.0574951171875,
        27.265396118164062,
        -195.98361206054688
      ],
      [
        1926.6937255859375,
        9.981322288513184,
        -219.18020629882812
      ],
      [
        1980.503173828125,
        28.340404510498047,
        -192.0364532470703
      ],
      [
        1926.6937255859375,
        9.981321334838867,
        -219.18020629882812
      ],
      [
        1913.8924560546875,
        5.126218795776367,
        -225.57406616210938
      ],
      [
        1996.4901123046875,
        -7.555739879608154,
        -178.57456970214844
      ],
      [
        1950.8455810546875,
        -24.917850494384766,
        -201.36605834960938
      ],
      [
        1934.2955322265625,
        -31.320560455322266,
        -209.6159210205078
      ],
      [
        1950.8455810546875,
        -24.91785430908203,
        -201.36605834960938
      ],
      [
        1934.2955322265625,
        -31.32056427001953,
        -209.6159210205078
      ],
      [
        1901.2532958984375,
        -40.097171783447266,
        -217.3973846435547
      ],
      [
        1933.8719482421875,
        -31.374244689941406,
        -209.84144592285156
      ],
      [
        1996.489990234375,
        -7.555759906768799,
        -178.5745849609375
      ],
      [
        1904.380615234375,
        -35.11184310913086,
        -225.54367065429688
      ],
      [
        1882.666259765625,
        -38.0546989440918,
        -237.08023071289062
      ],
      [
        1904.380615234375,
        -35.11183547973633,
        -225.54367065429688
      ],
      [
        1881.899658203125,
        -37.96098709106445,
        -237.51333618164062
      ],
      [
        1882.666259765625,
        -38.0546989440918,
        -237.08023071289062
      ],
      [
        1866.89013671875,
        -41.95500946044922,
        -241.03265380859375
      ],
      [
        1980.503173828125,
        28.340404510498047,
        -192.0364532470703
      ],
      [
        1973.0574951171875,
        27.265396118164062,
        -195.9835968017578
      ],
      [
        1867.1656494140625,
        -36.15998077392578,
        -245.83697509765625
      ],
      [
        1867.1656494140625,
        -36.159976959228516,
        -245.83697509765625
      ],
      [
        1864.068603515625,
        -35.56425857543945,
        -247.6151123046875
      ],
      [
        2261.883056640625,
        275.5967102050781,
        -76.98188781738281
      ],
      [
        2218.6015625,
        234.61196899414062,
        -98.32618713378906
      ],
      [
        1958.73193359375,
        -14.765510559082031,
        -221.83892822265625
      ],
      [
        1961.6868896484375,
        -8.669675827026367,
        -225.0238800048828
      ],
      [
        1958.73193359375,
        -14.765510559082031,
        -221.83892822265625
      ],
      [
        1957.400634765625,
        -18.029678344726562,
        -219.67483520507812
      ],
      [
        2001.51416015625,
        28.42502784729004,
        -204.51138305664062
      ],
      [
        1999.874267578125,
        27.450927734375,
        -206.13526916503906
      ],
      [
        1995.519775390625,
        26.284141540527344,
        -207.202392578125
      ],
      [
        2289.705322265625,
        300.3359680175781,
        -60.99939727783203
      ],
      [
        2291.53466796875,
        307.1632385253906,
        -60.99939727783203
      ],
      [
        2271.580810546875,
        296.51214599609375,
        -67.6260986328125
      ],
      [
        2292.80419921875,
        304.8771667480469,
        -61.733062744140625
      ],
      [
        2291.53466796875,
        307.1632385253906,
        -60.99939727783203
      ],
      [
        2289.705322265625,
        300.3359680175781,
        -60.99939727783203
      ],
      [
        2022.0577392578125,
        40.39495849609375,
        -183.845458984375
      ],
      [
        2001.51416015625,
        28.425025939941406,
        -204.51138305664062
      ],
      [
        1957.4007568359375,
        -18.02967643737793,
        -219.67483520507812
      ],
      [
        1958.620361328125,
        -19.45724105834961,
        -215.4375762939453
      ],
      [
        1961.823974609375,
        -23.944324493408203,
        -203.27020263671875
      ],
      [
        1958.620361328125,
        -19.457244873046875,
        -215.4375762939453
      ],
      [
        1961.823974609375,
        -23.944339752197266,
        -203.2702178955078
      ],
      [
        1962.240478515625,
        -23.694133758544922,
        -202.86187744140625
      ],
      [
        1935.3416748046875,
        -30.91581916809082,
        -209.0944061279297
      ],
      [
        2022.0716552734375,
        40.37964630126953,
        -183.79849243164062
      ],
      [
        2022.0716552734375,
        40.37964630126953,
        -183.79849243164062
      ],
      [
        2022.0577392578125,
        40.39495849609375,
        -183.845458984375
      ],
      [
        1966.75927734375,
        -20.979352951049805,
        -198.4313201904297
      ],
      [
        1976.853271484375,
        -15.025125503540039,
        -188.37973022460938
      ],
      [
        1966.759521484375,
        -20.97930145263672,
        -198.4312744140625
      ],
      [
        1995.519775390625,
        26.28414535522461,
        -207.202392578125
      ],
      [
        1999.874267578125,
        27.450931549072266,
        -206.13526916503906
      ],
      [
        1999.639892578125,
        27.269071578979492,
        -206.3074493408203
      ],
      [
        2193.515869140625,
        151.08786010742188,
        -133.99578857421875
      ],
      [
        2128.81298828125,
        90.35345458984375,
        -165.69549560546875
      ],
      [
        2193.515869140625,
        151.08786010742188,
        -133.99578857421875
      ],
      [
        2128.81298828125,
        90.35346221923828,
        -165.69549560546875
      ],
      [
        2043.0936279296875,
        5.74447774887085,
        -200.3142852783203
      ],
      [
        2123.156982421875,
        85.455078125,
        -168.30642700195312
      ],
      [
        2042.6373291015625,
        4.809405326843262,
        -199.82351684570312
      ],
      [
        2042.6500244140625,
        4.795225143432617,
        -199.78097534179688
      ],
      [
        2046.9158935546875,
        -0.9288576245307922,
        -184.1153564453125
      ],
      [
        2042.6500244140625,
        4.795225143432617,
        -199.78097534179688
      ],
      [
        2043.0936279296875,
        5.744477272033691,
        -200.3142852783203
      ],
      [
        2042.65087890625,
        4.842144012451172,
        -199.84515380859375
      ],
      [
        2042.65087890625,
        4.842144012451172,
        -199.84515380859375
      ],
      [
        2042.6373291015625,
        4.809404373168945,
        -199.82351684570312
      ],
      [
        2218.6015625,
        234.61196899414062,
        -98.3261947631836
      ],
      [
        2183.453857421875,
        201.13783264160156,
        -115.73396301269531
      ],
      [
        2003.110595703125,
        28.818544387817383,
        -204.1984100341797
      ],
      [
        1977.1131591796875,
        -14.926262855529785,
        -188.2499542236328
      ],
      [
        1967.2861328125,
        -20.84897804260254,
        -198.33416748046875
      ],
      [
        1962.566162109375,
        -23.745458602905273,
        -203.09912109375
      ],
      [
        1967.286376953125,
        -20.848913192749023,
        -198.33412170410156
      ],
      [
        1962.566162109375,
        -23.74544334411621,
        -203.09910583496094
      ],
      [
        1961.7969970703125,
        -23.906513214111328,
        -203.37274169921875
      ],
      [
        1962.544921875,
        -23.70647621154785,
        -203.19947814941406
      ],
      [
        1960.01171875,
        -19.055667877197266,
        -215.17832946777344
      ],
      [
        1959.036865234375,
        -17.59128189086914,
        -219.29379272460938
      ],
      [
        1960.01171875,
        -19.055665969848633,
        -215.17832946777344
      ],
      [
        1959.1170654296875,
        -17.413593292236328,
        -219.40797424316406
      ],
      [
        1959.0369873046875,
        -17.591217041015625,
        -219.29373168945312
      ],
      [
        1957.4735107421875,
        -17.850893020629883,
        -219.79336547851562
      ],
      [
        1960.4969482421875,
        -14.353127479553223,
        -221.37635803222656
      ],
      [
        1963.7550048828125,
        -8.099903106689453,
        -224.54527282714844
      ],
      [
        1960.4969482421875,
        -14.353128433227539,
        -221.37635803222656
      ],
      [
        2003.110595703125,
        28.818546295166016,
        -204.1984100341797
      ],
      [
        2001.634033203125,
        27.922470092773438,
        -205.70401000976562
      ],
      [
        2001.634033203125,
        27.922473907470703,
        -205.70401000976562
      ],
      [
        2001.31201171875,
        27.668800354003906,
        -205.94424438476562
      ],
      [
        2183.453857421875,
        201.13784790039062,
        -115.73396301269531
      ],
      [
        2118.8642578125,
        132.7657928466797,
        -150.39682006835938
      ],
      [
        2025.5728759765625,
        34.35565185546875,
        -199.79458618164062
      ],
      [
        1979.964111328125,
        -9.804632186889648,
        -216.2743377685547
      ],
      [
        1993.54443359375,
        0.10731887817382812,
        -217.65127563476562
      ],
      [
        2025.578125,
        34.33823776245117,
        -199.83628845214844
      ],
      [
        2024.91064453125,
        33.31020736694336,
        -200.81826782226562
      ],
      [
        2025.5728759765625,
        34.35565185546875,
        -199.79458618164062
      ],
      [
        2025.578125,
        34.33823776245117,
        -199.83628845214844
      ],
      [
        1979.964111328125,
        -9.804633140563965,
        -216.2743377685547
      ],
      [
        1975.021240234375,
        -13.308256149291992,
        -215.57106018066406
      ],
      [
        1975.0208740234375,
        -13.308365821838379,
        -215.57115173339844
      ],
      [
        1969.8326416015625,
        -16.221168518066406,
        -213.3484649658203
      ],
      [
        1961.1572265625,
        -21.15866470336914,
        -209.76174926757812
      ],
      [
        1969.8326416015625,
        -16.22117042541504,
        -213.3484649658203
      ],
      [
        2118.8642578125,
        132.7657928466797,
        -150.39682006835938
      ],
      [
        2031.8272705078125,
        39.94906234741211,
        -197.37252807617188
      ],
      [
        1980.8104248046875,
        -9.606904983520508,
        -216.05255126953125
      ],
      [
        1994.787841796875,
        0.4498710632324219,
        -217.36354064941406
      ],
      [
        1961.186767578125,
        -21.212860107421875,
        -209.62216186523438
      ],
      [
        1970.461181640625,
        -16.039758682250977,
        -213.23135375976562
      ],
      [
        1975.8104248046875,
        -13.096800804138184,
        -215.38726806640625
      ],
      [
        1970.461181640625,
        -16.039756774902344,
        -213.23135375976562
      ],
      [
        1976.1007080078125,
        -12.894207954406738,
        -215.4258575439453
      ],
      [
        1975.810546875,
        -13.096762657165527,
        -215.38723754882812
      ],
      [
        1975.3074951171875,
        -13.105323791503906,
        -215.61180114746094
      ],
      [
        1980.8104248046875,
        -9.606905937194824,
        -216.05255126953125
      ],
      [
        2025.8016357421875,
        33.523193359375,
        -200.62474060058594
      ],
      [
        2039.1016845703125,
        12.65869140625,
        -207.1082305908203
      ],
      [
        2043.2659912109375,
        5.445896148681641,
        -167.4436492919922
      ],
      [
        1997.40869140625,
        -6.904031753540039,
        -178.15530395507812
      ],
      [
        1976.1007080078125,
        -12.894208908081055,
        -215.4258575439453
      ],
      [
        2039.1016845703125,
        12.65869140625,
        -207.1082305908203
      ],
      [
        2303.001953125,
        286.5146179199219,
        -67.6260986328125
      ],
      [
        2303.001953125,
        286.5146179199219,
        -67.6260986328125
      ],
      [
        2300.03662109375,
        253.5687255859375,
        -80.83638000488281
      ],
      [
        2026.9034423828125,
        33.78660202026367,
        -200.38539123535156
      ],
      [
        2031.8272705078125,
        39.94905090332031,
        -197.37252807617188
      ],
      [
        2026.9034423828125,
        33.78660202026367,
        -200.38539123535156
      ],
      [
        307.42041015625,
        221.72091674804688,
        -353.6243896484375
      ],
      [
        307.9206237792969,
        262.761474609375,
        -337.6260986328125
      ],
      [
        2305.1923828125,
        294.6900329589844,
        -99.62260437011719
      ],
      [
        2305.1923828125,
        294.6900329589844,
        -99.62260437011719
      ],
      [
        2329.811279296875,
        360.0714111328125,
        -83.62440490722656
      ],
      [
        2329.811279296875,
        360.0714111328125,
        -83.62440490722656
      ],
      [
        2330.439453125,
        363.5322570800781,
        -82.95067596435547
      ],
      [
        1944.1302490234375,
        -9.803756713867188,
        -231.79920959472656
      ],
      [
        1944.1302490234375,
        -9.803763389587402,
        -231.79920959472656
      ],
      [
        1887.7503662109375,
        -25.860836029052734,
        -244.4630584716797
      ],
      [
        1700.0,
        -53.116764068603516,
        -279.8048400878906
      ],
      [
        1700.0,
        -53.11676025390625,
        -279.8048400878906
      ],
      [
        1433.9083251953125,
        -64.818359375,
        -349.51904296875
      ],
      [
        1391.863525390625,
        -52.900146484375,
        -348.9533386230469
      ],
      [
        1698.3134765625,
        -52.900146484375,
        -280.0020751953125
      ],
      [
        2303.88916015625,
        289.82672119140625,
        -99.62260437011719
      ],
      [
        2324.287353515625,
        339.4562072753906,
        -83.62440490722656
      ],
      [
        2303.88916015625,
        289.82672119140625,
        -99.62260437011719
      ],
      [
        2324.287353515625,
        339.4562072753906,
        -83.62440490722656
      ],
      [
        2328.17138671875,
        366.6565856933594,
        -75.95366668701172
      ],
      [
        1698.3134765625,
        -52.900146484375,
        -280.0020751953125
      ],
      [
        1391.863525390625,
        -52.900146484375,
        -348.95330810546875
      ],
      [
        1338.1435546875,
        -45.900146484375,
        -345.0421142578125
      ],
      [
        1508.2635498046875,
        -45.900146484375,
        -306.76513671875
      ],
      [
        1658.2877197265625,
        -75.21826171875,
        -299.03369140625
      ],
      [
        1445.4794921875,
        -75.21826171875,
        -346.91552734375
      ],
      [
        1433.908447265625,
        -64.818359375,
        -349.5190124511719
      ],
      [
        1563.231201171875,
        -87.0,
        -310.3955993652344
      ],
      [
        1429.8035888671875,
        -87.0,
        -340.41680908203125
      ],
      [
        1445.4794921875,
        -75.21826171875,
        -346.91552734375
      ],
      [
        1658.2877197265625,
        -75.21826171875,
        -299.0336608886719
      ],
      [
        1508.263427734375,
        -45.900146484375,
        -306.76513671875
      ],
      [
        1338.1435546875,
        -45.900146484375,
        -345.0421142578125
      ],
      [
        1305.829833984375,
        -51.83027648925781,
        -338.7595520019531
      ],
      [
        1401.5740966796875,
        -92.26988983154297,
        -334.8937072753906
      ],
      [
        1429.8035888671875,
        -87.0,
        -340.41680908203125
      ],
      [
        1563.231201171875,
        -87.0,
        -310.3956298828125
      ],
      [
        1550.800537109375,
        -87.8425064086914,
        -311.2940979003906
      ],
      [
        1780.43115234375,
        -56.42552185058594,
        -268.5687255859375
      ],
      [
        1700.0,
        -78.8938980102539,
        -286.5205993652344
      ],
      [
        1579.197265625,
        -87.0,
        -306.8032531738281
      ],
      [
        1780.43115234375,
        -56.4255256652832,
        -268.5687255859375
      ],
      [
        1700.0,
        -78.8938980102539,
        -286.5205993652344
      ],
      [
        1579.1973876953125,
        -87.0,
        -306.80322265625
      ],
      [
        2300.23779296875,
        339.6441345214844,
        -60.99939727783203
      ],
      [
        2278.128662109375,
        320.94842529296875,
        -67.6260986328125
      ],
      [
        2308.009033203125,
        299.8503112792969,
        -96.39147186279297
      ],
      [
        2319.166259765625,
        320.3440246582031,
        -83.62440490722656
      ],
      [
        2316.972900390625,
        338.65509033203125,
        -67.6260986328125
      ],
      [
        2300.23779296875,
        339.6441345214844,
        -60.99939727783203
      ],
      [
        2319.166259765625,
        320.3440246582031,
        -83.62440490722656
      ],
      [
        2316.972900390625,
        338.65509033203125,
        -67.6260986328125
      ],
      [
        2317.76416015625,
        329.54254150390625,
        -74.91072845458984
      ],
      [
        1671.887451171875,
        -48.81759262084961,
        -276.617431640625
      ],
      [
        1391.7713623046875,
        -94.099853515625,
        -332.975830078125
      ],
      [
        1550.800537109375,
        -87.8425064086914,
        -311.2940979003906
      ],
      [
        1493.922607421875,
        -91.69747161865234,
        -315.4051513671875
      ],
      [
        1391.7713623046875,
        -94.099853515625,
        -332.975830078125
      ],
      [
        1364.394287109375,
        -90.48906707763672,
        -330.9993896484375
      ],
      [
        1503.5233154296875,
        -91.3307113647461,
        -314.0714111328125
      ],
      [
        1548.8922119140625,
        -87.97184753417969,
        -311.4320373535156
      ],
      [
        1679.6343994140625,
        -49.230224609375,
        -275.8174133300781
      ],
      [
        1565.2587890625,
        -87.41354370117188,
        -309.007568359375
      ],
      [
        1548.370849609375,
        -89.61747741699219,
        -307.8411865234375
      ],
      [
        2014.673583984375,
        9.098278999328613,
        -215.0832061767578
      ],
      [
        2001.8140869140625,
        2.385662078857422,
        -215.73748779296875
      ],
      [
        2014.673583984375,
        9.098291397094727,
        -215.0832061767578
      ],
      [
        2056.6572265625,
        66.42776489257812,
        -183.97132873535156
      ],
      [
        2299.133544921875,
        335.5226135253906,
        -60.99939727783203
      ],
      [
        2276.83447265625,
        316.11859130859375,
        -67.6260986328125
      ],
      [
        2316.591796875,
        337.23248291015625,
        -67.6260986328125
      ],
      [
        2299.133544921875,
        335.5226135253906,
        -60.99939727783203
      ],
      [
        2316.591796875,
        337.23248291015625,
        -67.6260986328125
      ],
      [
        2015.551513671875,
        9.333526611328125,
        -214.87518310546875
      ],
      [
        2015.551513671875,
        9.333513259887695,
        -214.87518310546875
      ],
      [
        2004.3768310546875,
        3.0917320251464844,
        -215.14439392089844
      ],
      [
        2294.12158203125,
        316.81805419921875,
        -60.99939727783203
      ],
      [
        2273.24853515625,
        297.40240478515625,
        -67.07221221923828
      ],
      [
        2314.32177734375,
        328.7610168457031,
        -67.6260986328125
      ],
      [
        2294.12158203125,
        316.81805419921875,
        -60.99939727783203
      ],
      [
        2318.302978515625,
        326.0071716308594,
        -78.2597427368164
      ],
      [
        2314.32177734375,
        328.7610168457031,
        -67.6260986328125
      ],
      [
        2293.04931640625,
        245.19473266601562,
        -86.25222778320312
      ],
      [
        2282.205810546875,
        234.337646484375,
        -90.5443344116211
      ],
      [
        2300.915771484375,
        253.0611114501953,
        -83.12399291992188
      ],
      [
        2293.04931640625,
        245.19473266601562,
        -86.25222778320312
      ],
      [
        2300.925537109375,
        253.08055114746094,
        -83.13448333740234
      ],
      [
        2300.915771484375,
        253.0611114501953,
        -83.12399291992188
      ],
      [
        2301.386474609375,
        253.9889678955078,
        -83.62440490722656
      ],
      [
        2301.386474609375,
        253.9889678955078,
        -83.62440490722656
      ],
      [
        2293.80615234375,
        315.6408386230469,
        -60.99939727783203
      ],
      [
        2275.556640625,
        298.6343994140625,
        -66.30570983886719
      ],
      [
        2314.15625,
        328.1429748535156,
        -67.6260986328125
      ],
      [
        2293.80615234375,
        315.6408386230469,
        -60.99939727783203
      ],
      [
        2318.326904296875,
        325.8505859375,
        -78.40807342529297
      ],
      [
        2314.15625,
        328.1429748535156,
        -67.6260986328125
      ],
      [
        2304.569091796875,
        322.25311279296875,
        -64.50419616699219
      ],
      [
        2292.657470703125,
        305.14166259765625,
        -61.64817428588867
      ],
      [
        2304.728759765625,
        322.3512268066406,
        -64.55620574951172
      ],
      [
        2292.804443359375,
        304.87713623046875,
        -61.733070373535156
      ],
      [
        307.42041015625,
        221.72091674804688,
        -353.6243896484375
      ],
      [
        459.78045654296875,
        180.34259033203125,
        -369.62261962890625
      ],
      [
        459.9652404785156,
        221.38363647460938,
        -353.6243896484375
      ],
      [
        307.920654296875,
        262.761474609375,
        -337.6260986328125
      ],
      [
        1372.7384033203125,
        -64.818359375,
        -363.28228759765625
      ],
      [
        1333.60302734375,
        -52.900146484375,
        -362.06195068359375
      ],
      [
        1333.60302734375,
        -52.900146484375,
        -362.06195068359375
      ],
      [
        1397.7003173828125,
        -75.21826171875,
        -357.66583251953125
      ],
      [
        1372.73828125,
        -64.818359375,
        -363.28228759765625
      ],
      [
        1415.4498291015625,
        -87.0,
        -343.6463928222656
      ],
      [
        1397.7003173828125,
        -75.21826171875,
        -357.66583251953125
      ],
      [
        1415.4498291015625,
        -87.0,
        -343.6463928222656
      ],
      [
        1415.539794921875,
        -89.66277313232422,
        -337.6260986328125
      ],
      [
        567.7012939453125,
        180.10397338867188,
        -369.62261962890625
      ],
      [
        459.96527099609375,
        221.38363647460938,
        -353.6243896484375
      ],
      [
        1334.2752685546875,
        -64.818359375,
        -371.9364929199219
      ],
      [
        1381.6051025390625,
        -75.21826171875,
        -361.2872314453125
      ],
      [
        1334.275390625,
        -64.818359375,
        -371.9364318847656
      ],
      [
        1381.6051025390625,
        -75.21826171875,
        -361.2872314453125
      ],
      [
        1402.8170166015625,
        -78.61463165283203,
        -353.6243896484375
      ],
      [
        459.7804260253906,
        180.34259033203125,
        -369.62261962890625
      ],
      [
        578.4675903320312,
        154.3602294921875,
        -379.6484069824219
      ],
      [
        611.3817138671875,
        154.28744506835938,
        -379.6484069824219
      ],
      [
        567.7013549804688,
        180.10397338867188,
        -369.62261962890625
      ],
      [
        1344.5589599609375,
        -67.07801055908203,
        -369.62261962890625
      ],
      [
        578.4675903320312,
        154.3602294921875,
        -379.6484069824219
      ],
      [
        611.3817749023438,
        154.2874298095703,
        -379.6484069824219
      ],
      [
        -1669.793701171875,
        353.7113342285156,
        -303.8778076171875
      ],
      [
        -1642.22119140625,
        352.099853515625,
        -313.36553955078125
      ],
      [
        -1586.8519287109375,
        355.94830322265625,
        -316.2267150878906
      ],
      [
        -1704.28369140625,
        342.7159423828125,
        -308.193603515625
      ],
      [
        -1642.2213134765625,
        352.099853515625,
        -313.3655090332031
      ],
      [
        226.1934814453125,
        266.44744873046875,
        -379.6484069824219
      ],
      [
        263.3448791503906,
        265.02642822265625,
        -379.6484069824219
      ],
      [
        226.1934814453125,
        266.44744873046875,
        -379.6484069824219
      ],
      [
        263.34490966796875,
        265.02642822265625,
        -379.6484069824219
      ],
      [
        321.814453125,
        258.3406982421875,
        -369.62261962890625
      ],
      [
        321.814453125,
        258.3406982421875,
        -369.62261962890625
      ],
      [
        372.1831359863281,
        249.31431579589844,
        -353.6243896484375
      ],
      [
        234.4552459716797,
        249.75967407226562,
        -342.757568359375
      ],
      [
        372.18310546875,
        249.31431579589844,
        -353.6243896484375
      ],
      [
        372.3886413574219,
        245.21697998046875,
        -344.40948486328125
      ],
      [
        238.35134887695312,
        272.97894287109375,
        -379.6484069824219
      ],
      [
        313.8623046875,
        259.25,
        -370.9861755371094
      ],
      [
        238.35133361816406,
        272.97894287109375,
        -379.6484069824219
      ],
      [
        -1587.30615234375,
        318.0,
        -324.9266052246094
      ],
      [
        -1587.30615234375,
        318.0,
        -324.9266052246094
      ],
      [
        -1657.635009765625,
        324.1795349121094,
        -315.3790283203125
      ],
      [
        365.8841552734375,
        251.3185272216797,
        -353.6243896484375
      ],
      [
        321.7821350097656,
        258.9891662597656,
        -339.0846252441406
      ],
      [
        365.8841857910156,
        251.3185272216797,
        -353.6243896484375
      ],
      [
        365.9268798828125,
        250.43548583984375,
        -355.61151123046875
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.638517439365387,
        0.17109034955501556,
        0.7503489851951599
      ],
      "plane_d": 1496.2386474609375,
      "bbox_min": [
        2366.01318359375,
        565.6466064453125,
        -109.64839935302734
      ],
      "bbox_max": [
        2394.099853515625,
        600.0,
        -80.33102416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.887794554233551,
        0.2378837764263153,
        0.3939950168132782
      ],
      "plane_d": 2015.6861572265625,
      "bbox_min": [
        2380.913818359375,
        577.2861938476562,
        -99.62260437011719
      ],
      "bbox_max": [
        2394.099853515625,
        600.0,
        -80.33102416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877955079078674,
        0.23788398504257202,
        -0.3939928412437439
      ],
      "plane_d": 1949.793212890625,
      "bbox_min": [
        2291.62353515625,
        352.44757080078125,
        -109.64839935302734
      ],
      "bbox_max": [
        2393.048828125,
        600.0,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3614806830883026,
        0.0968584343791008,
        -0.9273349642753601
      ],
      "plane_d": 742.0272827148438,
      "bbox_min": [
        2291.62353515625,
        352.44757080078125,
        -109.64839935302734
      ],
      "bbox_max": [
        2393.048828125,
        600.0,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3596632182598114,
        -0.09637141972780228,
        -0.9280920028686523
      ],
      "plane_d": -851.1920166015625,
      "bbox_min": [
        2291.62353515625,
        352.44757080078125,
        -109.64839935302734
      ],
      "bbox_max": [
        2393.048828125,
        600.0,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.887794554233551,
        0.2378837764263153,
        0.3939950168132782
      ],
      "plane_d": 2015.6861572265625,
      "bbox_min": [
        2308.88671875,
        352.44757080078125,
        -109.64839935302734
      ],
      "bbox_max": [
        2393.048828125,
        596.0772705078125,
        -83.62440490722656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.638517439365387,
        0.17109034955501556,
        0.7503489851951599
      ],
      "plane_d": 1496.2386474609375,
      "bbox_min": [
        2308.88671875,
        352.44757080078125,
        -109.64839935302734
      ],
      "bbox_max": [
        2380.913818359375,
        577.2862548828125,
        -99.62260437011719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3043372333049774,
        -0.3442048728466034,
        -0.8882014751434326
      ],
      "plane_d": -755.523681640625,
      "bbox_min": [
        1700.0,
        -70.0,
        -247.6260986328125
      ],
      "bbox_max": [
        1840.805419921875,
        -31.938758850097656,
        -215.77200317382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32594844698905945,
        -0.8661088943481445,
        -0.3789629638195038
      ],
      "plane_d": -693.770751953125,
      "bbox_min": [
        1700.0,
        -60.19097900390625,
        -247.6260986328125
      ],
      "bbox_max": [
        1840.805419921875,
        -31.938758850097656,
        -215.77200317382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32702600955963135,
        -0.8577760457992554,
        -0.39657825231552124
      ],
      "plane_d": -699.5238037109375,
      "bbox_min": [
        1700.0,
        -60.19097900390625,
        -247.6260986328125
      ],
      "bbox_max": [
        1840.805419921875,
        -34.78263854980469,
        -215.77200317382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0864366814494133,
        0.4499818980693817,
        -0.8888447284698486
      ],
      "plane_d": -327.89508056640625,
      "bbox_min": [
        1784.12109375,
        -60.19097900390625,
        -225.87344360351562
      ],
      "bbox_max": [
        1840.805419921875,
        -48.552371978759766,
        -215.77200317382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15444743633270264,
        0.9102742671966553,
        -0.38411810994148254
      ],
      "plane_d": 246.6368408203125,
      "bbox_min": [
        1818.2681884765625,
        -55.31013107299805,
        -220.0818328857422
      ],
      "bbox_max": [
        1840.805419921875,
        -50.18458557128906,
        -215.77200317382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32594844698905945,
        -0.8661088943481445,
        -0.3789629638195038
      ],
      "plane_d": -693.770751953125,
      "bbox_min": [
        1700.0,
        -52.900146484375,
        -263.6243896484375
      ],
      "bbox_max": [
        1852.6746826171875,
        -29.092744827270508,
        -216.9972686767578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15444743633270264,
        0.9102742671966553,
        -0.38411810994148254
      ],
      "plane_d": 246.6368408203125,
      "bbox_min": [
        1828.864990234375,
        -52.900142669677734,
        -220.57640075683594
      ],
      "bbox_max": [
        1852.6746826171875,
        -49.70515441894531,
        -216.9972686767578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14970317482948303,
        0.9037337303161621,
        -0.4010663628578186
      ],
      "plane_d": 233.80572509765625,
      "bbox_min": [
        1848.431640625,
        -50.26443862915039,
        -220.57640075683594
      ],
      "bbox_max": [
        1852.6746826171875,
        -49.70515441894531,
        -219.8986053466797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32138189673423767,
        0.8655436635017395,
        0.38411957025527954
      ],
      "plane_d": 729.06005859375,
      "bbox_min": [
        1616.8890380859375,
        -94.099853515625,
        -298.3226013183594
      ],
      "bbox_max": [
        1867.70947265625,
        -37.43697738647461,
        -218.63150024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14970317482948303,
        0.9037337303161621,
        -0.4010663628578186
      ],
      "plane_d": 233.80572509765625,
      "bbox_min": [
        1616.8890380859375,
        -94.099853515625,
        -298.3226013183594
      ],
      "bbox_max": [
        1867.3280029296875,
        -37.43697738647461,
        -218.63150024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.168893501162529,
        0.6387627124786377,
        0.7506378293037415
      ],
      "plane_d": 552.586669921875,
      "bbox_min": [
        1616.8890380859375,
        -87.0,
        -298.3226013183594
      ],
      "bbox_max": [
        1858.846435546875,
        -37.43697738647461,
        -248.01731872558594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08982798457145691,
        -0.912437379360199,
        0.3992355167865753
      ],
      "plane_d": 216.07479858398438,
      "bbox_min": [
        1617.1143798828125,
        -50.31498336791992,
        -282.273681640625
      ],
      "bbox_max": [
        1858.846435546875,
        -37.43697738647461,
        -248.01731872558594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14567448198795319,
        -0.9063680768013,
        0.3965801000595093
      ],
      "plane_d": -184.70086669921875,
      "bbox_min": [
        1700.0,
        -50.31498336791992,
        -273.7143249511719
      ],
      "bbox_max": [
        1858.846435546875,
        -37.43697738647461,
        -248.01731872558594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32992932200431824,
        0.5578283667564392,
        0.7615602612495422
      ],
      "plane_d": 823.4234619140625,
      "bbox_min": [
        1832.5479736328125,
        -44.2484130859375,
        -254.90972900390625
      ],
      "bbox_max": [
        1858.846435546875,
        -37.43697738647461,
        -248.01731872558594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2921886146068573,
        -0.2449796199798584,
        -0.9244516491889954
      ],
      "plane_d": -738.5984497070312,
      "bbox_min": [
        1762.55517578125,
        -50.351646423339844,
        -254.58726501464844
      ],
      "bbox_max": [
        2035.0,
        30.796566009521484,
        -160.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3043372333049774,
        -0.3442048728466034,
        -0.8882014751434326
      ],
      "plane_d": -755.523681640625,
      "bbox_min": [
        1769.311279296875,
        -45.72816848754883,
        -229.70309448242188
      ],
      "bbox_max": [
        2035.0,
        19.76297950744629,
        -160.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1242138147354126,
        0.3603757321834564,
        -0.924500048160553
      ],
      "plane_d": -408.74114990234375,
      "bbox_min": [
        1793.3388671875,
        -45.72816848754883,
        -218.7095184326172
      ],
      "bbox_max": [
        2035.0,
        19.76297950744629,
        -160.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15077416598796844,
        -0.9130459427833557,
        0.3789648115634918
      ],
      "plane_d": -198.32064819335938,
      "bbox_min": [
        1762.72607421875,
        -50.351646423339844,
        -254.58726501464844
      ],
      "bbox_max": [
        1988.263427734375,
        15.2890625,
        -180.4905242919922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15444743633270264,
        0.9102742671966553,
        -0.38411810994148254
      ],
      "plane_d": 246.6368408203125,
      "bbox_min": [
        1769.244873046875,
        -50.351646423339844,
        -254.58726501464844
      ],
      "bbox_max": [
        1988.263427734375,
        -2.3461685180664062,
        -180.4905242919922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14567448198795319,
        -0.9063680768013,
        0.3965801000595093
      ],
      "plane_d": -184.70086669921875,
      "bbox_min": [
        1769.244873046875,
        -49.07025146484375,
        -254.58726501464844
      ],
      "bbox_max": [
        1901.2532958984375,
        -2.3461685180664062,
        -217.3973846435547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3222202956676483,
        0.8575069904327393,
        0.40106838941574097
      ],
      "plane_d": 734.1971435546875,
      "bbox_min": [
        1867.3546142578125,
        -49.07025146484375,
        -231.92408752441406
      ],
      "bbox_max": [
        1901.2532958984375,
        -40.097171783447266,
        -217.3973846435547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7216687202453613,
        0.5632971525192261,
        0.40235620737075806
      ],
      "plane_d": 1551.7984619140625,
      "bbox_min": [
        2043.5,
        -1.3341636657714844,
        -184.1249542236328
      ],
      "bbox_max": [
        2278.818603515625,
        230.66043090820312,
        -92.39784240722656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7250920534133911,
        0.5734594464302063,
        0.3812946379184723
      ],
      "plane_d": 1554.9501953125,
      "bbox_min": [
        2046.9158935546875,
        -1.108106017112732,
        -184.1249542236328
      ],
      "bbox_max": [
        2054.806396484375,
        6.951882839202881,
        -180.9961700439453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3222202956676483,
        0.8575069904327393,
        0.40106838941574097
      ],
      "plane_d": 734.1971435546875,
      "bbox_min": [
        2046.9158935546875,
        -1.108106017112732,
        -184.1249542236328
      ],
      "bbox_max": [
        2047.0499267578125,
        -0.9157277941703796,
        -183.62440490722656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3222202956676483,
        0.8575069904327393,
        0.40106838941574097
      ],
      "plane_d": 734.1971435546875,
      "bbox_min": [
        2046.206298828125,
        -1.3341636657714844,
        -184.11534118652344
      ],
      "bbox_max": [
        2047.0499267578125,
        -0.9288614392280579,
        -183.62440490722656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14567448198795319,
        -0.9063680768013,
        0.3965801000595093
      ],
      "plane_d": -184.70086669921875,
      "bbox_min": [
        1851.7620849609375,
        -46.04069900512695,
        -249.18817138671875
      ],
      "bbox_max": [
        2035.0,
        34.5718879699707,
        -160.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15444743633270264,
        0.9102742671966553,
        -0.38411810994148254
      ],
      "plane_d": 246.6368408203125,
      "bbox_min": [
        1857.271240234375,
        -46.04069900512695,
        -249.18817138671875
      ],
      "bbox_max": [
        2035.0,
        34.5718879699707,
        -160.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0864366814494133,
        0.4499818980693817,
        -0.8888447284698486
      ],
      "plane_d": -327.89508056640625,
      "bbox_min": [
        1857.271240234375,
        -46.04069900512695,
        -249.18817138671875
      ],
      "bbox_max": [
        2035.0,
        34.5718879699707,
        -160.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32594844698905945,
        -0.8661088943481445,
        -0.3789629638195038
      ],
      "plane_d": -693.770751953125,
      "bbox_min": [
        1857.271240234375,
        -41.95500946044922,
        -249.18817138671875
      ],
      "bbox_max": [
        2035.0,
        34.5718879699707,
        -160.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2921886146068573,
        -0.2449796199798584,
        -0.9244516491889954
      ],
      "plane_d": -738.5984497070312,
      "bbox_min": [
        1857.271240234375,
        -41.95500946044922,
        -249.18817138671875
      ],
      "bbox_max": [
        2035.0,
        34.5718879699707,
        -160.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33120739459991455,
        0.6114946007728577,
        0.718593180179596
      ],
      "plane_d": 817.1875,
      "bbox_min": [
        1857.271240234375,
        -41.95500946044922,
        -249.18817138671875
      ],
      "bbox_max": [
        1881.899658203125,
        -35.56425857543945,
        -237.51333618164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32992932200431824,
        0.5578283667564392,
        0.7615602612495422
      ],
      "plane_d": 823.4234619140625,
      "bbox_min": [
        1857.271240234375,
        -38.10376739501953,
        -249.18817138671875
      ],
      "bbox_max": [
        1867.1656494140625,
        -35.56425857543945,
        -245.83697509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33120739459991455,
        0.6114946007728577,
        0.718593180179596
      ],
      "plane_d": 817.1875,
      "bbox_min": [
        1867.1656494140625,
        -38.0546989440918,
        -245.83697509765625
      ],
      "bbox_max": [
        2292.80419921875,
        307.1632385253906,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15077416598796844,
        -0.9130459427833557,
        0.3789648115634918
      ],
      "plane_d": -198.32064819335938,
      "bbox_min": [
        1882.666259765625,
        -38.0546989440918,
        -237.08023071289062
      ],
      "bbox_max": [
        2026.4500732421875,
        40.39495849609375,
        -167.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32138189673423767,
        0.8655436635017395,
        0.38411957025527954
      ],
      "plane_d": 729.06005859375,
      "bbox_min": [
        1882.666259765625,
        -38.0546989440918,
        -237.08023071289062
      ],
      "bbox_max": [
        2026.4500732421875,
        40.39495849609375,
        -167.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32702600955963135,
        -0.8577760457992554,
        -0.39657825231552124
      ],
      "plane_d": -699.5238037109375,
      "bbox_min": [
        1935.3416748046875,
        -30.91581916809082,
        -209.0944061279297
      ],
      "bbox_max": [
        2026.4500732421875,
        40.39495849609375,
        -167.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32594844698905945,
        -0.8661088943481445,
        -0.3789629638195038
      ],
      "plane_d": -693.770751953125,
      "bbox_min": [
        1935.3416748046875,
        -30.91581916809082,
        -209.0944061279297
      ],
      "bbox_max": [
        2022.0716552734375,
        40.39495849609375,
        -183.79849243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14970317482948303,
        0.9037337303161621,
        -0.4010663628578186
      ],
      "plane_d": 233.80572509765625,
      "bbox_min": [
        1935.3416748046875,
        -30.91581916809082,
        -209.0944061279297
      ],
      "bbox_max": [
        1999.874267578125,
        27.450931549072266,
        -188.37973022460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15444743633270264,
        0.9102742671966553,
        -0.38411810994148254
      ],
      "plane_d": 246.6368408203125,
      "bbox_min": [
        1950.8455810546875,
        -24.917850494384766,
        -201.36605834960938
      ],
      "bbox_max": [
        1976.853271484375,
        -15.025125503540039,
        -188.37973022460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.009485919959843159,
        -0.693903386592865,
        0.7200056910514832
      ],
      "plane_d": 148.4962158203125,
      "bbox_min": [
        1995.519775390625,
        26.28414535522461,
        -207.202392578125
      ],
      "bbox_max": [
        1999.874267578125,
        27.450931549072266,
        -206.13526916503906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6197510957717896,
        0.33810123801231384,
        0.708234429359436
      ],
      "plane_d": 1406.1368408203125,
      "bbox_min": [
        2042.6373291015625,
        -0.9288576245307922,
        -200.3142852783203
      ],
      "bbox_max": [
        2128.81298828125,
        90.35346221923828,
        -165.69549560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3222202956676483,
        0.8575069904327393,
        0.40106838941574097
      ],
      "plane_d": 734.1971435546875,
      "bbox_min": [
        2042.6373291015625,
        -0.9288576245307922,
        -200.3142852783203
      ],
      "bbox_max": [
        2046.9388427734375,
        5.744477272033691,
        -184.1153564453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.15444743633270264,
        0.9102742671966553,
        -0.38411810994148254
      ],
      "plane_d": 246.6368408203125,
      "bbox_min": [
        1957.400634765625,
        -23.944339752197266,
        -225.0238800048828
      ],
      "bbox_max": [
        2003.110595703125,
        28.818546295166016,
        -188.2499542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3222202956676483,
        0.8575069904327393,
        0.40106838941574097
      ],
      "plane_d": 734.1971435546875,
      "bbox_min": [
        1957.400634765625,
        -23.906513214111328,
        -225.0238800048828
      ],
      "bbox_max": [
        2003.110595703125,
        28.818546295166016,
        -203.19947814941406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32992932200431824,
        0.5578283667564392,
        0.7615602612495422
      ],
      "plane_d": 823.4234619140625,
      "bbox_min": [
        1957.4735107421875,
        -17.850893020629883,
        -225.0238800048828
      ],
      "bbox_max": [
        2003.110595703125,
        28.818546295166016,
        -204.1984100341797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33120739459991455,
        0.6114946007728577,
        0.718593180179596
      ],
      "plane_d": 817.1875,
      "bbox_min": [
        1957.4735107421875,
        -17.850893020629883,
        -221.83892822265625
      ],
      "bbox_max": [
        2003.110595703125,
        28.818546295166016,
        -204.1984100341797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14567448198795319,
        -0.9063680768013,
        0.3965801000595093
      ],
      "plane_d": -184.70086669921875,
      "bbox_min": [
        1999.639892578125,
        27.269071578979492,
        -206.3074493408203
      ],
      "bbox_max": [
        2003.110595703125,
        28.818546295166016,
        -204.1984100341797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.009485919959843159,
        -0.693903386592865,
        0.7200056910514832
      ],
      "plane_d": 148.4962158203125,
      "bbox_min": [
        1999.639892578125,
        27.269071578979492,
        -206.3074493408203
      ],
      "bbox_max": [
        2001.634033203125,
        27.922473907470703,
        -205.70401000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14567448198795319,
        -0.9063680768013,
        0.3965801000595093
      ],
      "plane_d": -184.70086669921875,
      "bbox_min": [
        1959.036865234375,
        -21.15866470336914,
        -221.37635803222656
      ],
      "bbox_max": [
        2025.578125,
        34.35565185546875,
        -199.79458618164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33120739459991455,
        0.6114946007728577,
        0.718593180179596
      ],
      "plane_d": 817.1875,
      "bbox_min": [
        1959.036865234375,
        -21.15866470336914,
        -221.37635803222656
      ],
      "bbox_max": [
        1979.964111328125,
        -9.804633140563965,
        -209.76174926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32138189673423767,
        0.8655436635017395,
        0.38411957025527954
      ],
      "plane_d": 729.06005859375,
      "bbox_min": [
        1959.036865234375,
        -21.15866470336914,
        -219.29379272460938
      ],
      "bbox_max": [
        1975.0208740234375,
        -13.308365821838379,
        -209.76174926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3222202956676483,
        0.8575069904327393,
        0.40106838941574097
      ],
      "plane_d": 734.1971435546875,
      "bbox_min": [
        1960.01171875,
        -21.15866470336914,
        -215.17832946777344
      ],
      "bbox_max": [
        1969.8326416015625,
        -16.22117042541504,
        -209.76174926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32992932200431824,
        0.5578283667564392,
        0.7615602612495422
      ],
      "plane_d": 823.4234619140625,
      "bbox_min": [
        1961.1572265625,
        -21.212860107421875,
        -217.65127563476562
      ],
      "bbox_max": [
        2026.4500732421875,
        34.5718879699707,
        -199.6226043701172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3222202956676483,
        0.8575069904327393,
        0.40106838941574097
      ],
      "plane_d": 734.1971435546875,
      "bbox_min": [
        1961.1572265625,
        -21.212860107421875,
        -216.2743377685547
      ],
      "bbox_max": [
        2026.4500732421875,
        34.5718879699707,
        -199.6226043701172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33120739459991455,
        0.6114946007728577,
        0.718593180179596
      ],
      "plane_d": 817.1875,
      "bbox_min": [
        1975.3074951171875,
        -13.105323791503906,
        -216.2743377685547
      ],
      "bbox_max": [
        2026.4500732421875,
        34.5718879699707,
        -199.6226043701172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.009485919959843159,
        -0.693903386592865,
        0.7200056910514832
      ],
      "plane_d": 148.4962158203125,
      "bbox_min": [
        2024.91064453125,
        33.31020736694336,
        -200.81826782226562
      ],
      "bbox_max": [
        2026.4500732421875,
        34.5718879699707,
        -199.6226043701172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14970317482948303,
        0.9037337303161621,
        -0.4010663628578186
      ],
      "plane_d": 233.80572509765625,
      "bbox_min": [
        1961.186767578125,
        -23.745458602905273,
        -217.36354064941406
      ],
      "bbox_max": [
        2303.001953125,
        304.8771667480469,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15444743633270264,
        0.9102742671966553,
        -0.38411810994148254
      ],
      "plane_d": 246.6368408203125,
      "bbox_min": [
        1967.2861328125,
        -20.84897804260254,
        -198.33416748046875
      ],
      "bbox_max": [
        2046.2012939453125,
        5.445896148681641,
        -167.4436492919922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3222202956676483,
        0.8575069904327393,
        0.40106838941574097
      ],
      "plane_d": 734.1971435546875,
      "bbox_min": [
        1961.186767578125,
        -23.74544334411621,
        -217.36354064941406
      ],
      "bbox_max": [
        2303.001953125,
        304.8771667480469,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32138189673423767,
        0.8655436635017395,
        0.38411957025527954
      ],
      "plane_d": 729.06005859375,
      "bbox_min": [
        1970.461181640625,
        -16.039756774902344,
        -215.4258575439453
      ],
      "bbox_max": [
        2042.6500244140625,
        4.809405326843262,
        -199.78097534179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3596632182598114,
        -0.09637141972780228,
        -0.9280920028686523
      ],
      "plane_d": -851.1920166015625,
      "bbox_min": [
        2025.8016357421875,
        33.523193359375,
        -200.62474060058594
      ],
      "bbox_max": [
        2303.001953125,
        300.3359680175781,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877955079078674,
        0.23788398504257202,
        -0.3939928412437439
      ],
      "plane_d": 1949.793212890625,
      "bbox_min": [
        2025.8016357421875,
        33.523193359375,
        -200.62474060058594
      ],
      "bbox_max": [
        2303.001953125,
        286.5146179199219,
        -67.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2677270770072937,
        -0.5873310565948486,
        0.7637829780578613
      ],
      "plane_d": -369.7620849609375,
      "bbox_min": [
        2025.8016357421875,
        33.523193359375,
        -200.62474060058594
      ],
      "bbox_max": [
        2031.8272705078125,
        39.94905090332031,
        -197.37252807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.009485919959843159,
        -0.693903386592865,
        0.7200056910514832
      ],
      "plane_d": 148.4962158203125,
      "bbox_min": [
        2025.8016357421875,
        33.523193359375,
        -200.62474060058594
      ],
      "bbox_max": [
        2026.9034423828125,
        34.5718879699707,
        -199.6226043701172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.638517439365387,
        0.17109034955501556,
        0.7503489851951599
      ],
      "plane_d": 1496.2386474609375,
      "bbox_min": [
        2284.756103515625,
        262.390869140625,
        -109.64839935302734
      ],
      "bbox_max": [
        2330.657958984375,
        363.5322570800781,
        -82.95067596435547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.887794554233551,
        0.2378837764263153,
        0.3939950168132782
      ],
      "plane_d": 2015.6861572265625,
      "bbox_min": [
        2305.1923828125,
        294.6900329589844,
        -99.62260437011719
      ],
      "bbox_max": [
        2330.657958984375,
        363.5322570800781,
        -82.95067596435547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877955079078674,
        0.23788398504257202,
        -0.3939928412437439
      ],
      "plane_d": 1949.793212890625,
      "bbox_min": [
        2329.811279296875,
        360.0714111328125,
        -83.62440490722656
      ],
      "bbox_max": [
        2330.657958984375,
        363.5322570800781,
        -82.95067596435547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2339862734079361,
        0.0,
        0.9722398519515991
      ],
      "plane_d": 679.3843994140625,
      "bbox_min": [
        1305.829833984375,
        -92.26988983154297,
        -349.51904296875
      ],
      "bbox_max": [
        2330.439453125,
        366.6565856933594,
        -75.95366668701172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19968415796756744,
        -0.11528770625591278,
        0.9730544686317444
      ],
      "plane_d": 612.635009765625,
      "bbox_min": [
        1700.0,
        -75.21826171875,
        -289.6484069824219
      ],
      "bbox_max": [
        2032.4091796875,
        24.250411987304688,
        -209.64840698242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.887794554233551,
        0.2378837764263153,
        0.3939950168132782
      ],
      "plane_d": 2015.6861572265625,
      "bbox_min": [
        2284.756103515625,
        262.390869140625,
        -109.64839935302734
      ],
      "bbox_max": [
        2330.439453125,
        366.6565856933594,
        -75.95366668701172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.638517439365387,
        0.17109034955501556,
        0.7503489851951599
      ],
      "plane_d": 1496.2386474609375,
      "bbox_min": [
        2284.756103515625,
        262.390869140625,
        -109.64839935302734
      ],
      "bbox_max": [
        2330.439453125,
        366.6565856933594,
        -75.95366668701172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2195121943950653,
        0.0,
        0.9756097793579102
      ],
      "plane_d": 655.7545166015625,
      "bbox_min": [
        1305.829833984375,
        -92.26988983154297,
        -349.5190124511719
      ],
      "bbox_max": [
        1700.0,
        -45.900146484375,
        -289.6484069824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.168893501162529,
        0.6387627124786377,
        0.7506378293037415
      ],
      "plane_d": 552.586669921875,
      "bbox_min": [
        1305.829833984375,
        -92.26988983154297,
        -346.91552734375
      ],
      "bbox_max": [
        1658.2877197265625,
        -45.900146484375,
        -299.0336608886719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08982770889997482,
        -0.9124379754066467,
        -0.39923423528671265
      ],
      "plane_d": -299.8360290527344,
      "bbox_min": [
        1305.829833984375,
        -92.26988983154297,
        -345.0421142578125
      ],
      "bbox_max": [
        1563.231201171875,
        -45.900146484375,
        -306.76513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09089095890522003,
        0.9102500677108765,
        0.40395984053611755
      ],
      "plane_d": 346.6627197265625,
      "bbox_min": [
        1401.5740966796875,
        -92.26988983154297,
        -340.41680908203125
      ],
      "bbox_max": [
        1563.231201171875,
        -87.0,
        -310.3956298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33120739459991455,
        0.6114946007728577,
        0.718593180179596
      ],
      "plane_d": 817.1875,
      "bbox_min": [
        1550.800537109375,
        -87.8425064086914,
        -311.2940979003906
      ],
      "bbox_max": [
        1780.43115234375,
        -56.4255256652832,
        -268.5687255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2195121943950653,
        0.0,
        0.9756097793579102
      ],
      "plane_d": 655.7545166015625,
      "bbox_min": [
        1550.800537109375,
        -87.8425064086914,
        -311.2940979003906
      ],
      "bbox_max": [
        1700.0,
        -64.818359375,
        -289.6484069824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09089095890522003,
        0.9102500677108765,
        0.40395984053611755
      ],
      "plane_d": 346.6627197265625,
      "bbox_min": [
        1550.800537109375,
        -87.8425064086914,
        -311.2940979003906
      ],
      "bbox_max": [
        1579.1973876953125,
        -87.0,
        -306.80322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3596632182598114,
        -0.09637141972780228,
        -0.9280920028686523
      ],
      "plane_d": -851.1920166015625,
      "bbox_min": [
        2278.128662109375,
        299.8503112792969,
        -96.39147186279297
      ],
      "bbox_max": [
        2328.17138671875,
        373.72052001953125,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.887794554233551,
        0.2378837764263153,
        0.3939950168132782
      ],
      "plane_d": 2015.6861572265625,
      "bbox_min": [
        2300.23779296875,
        299.8503112792969,
        -96.39147186279297
      ],
      "bbox_max": [
        2328.17138671875,
        373.72052001953125,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3614806830883026,
        0.0968584343791008,
        -0.9273349642753601
      ],
      "plane_d": 742.0272827148438,
      "bbox_min": [
        2300.23779296875,
        320.3440246582031,
        -83.62440490722656
      ],
      "bbox_max": [
        2328.17138671875,
        373.72052001953125,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877955079078674,
        0.23788398504257202,
        -0.3939928412437439
      ],
      "plane_d": 1949.793212890625,
      "bbox_min": [
        2316.972900390625,
        320.3440246582031,
        -83.62440490722656
      ],
      "bbox_max": [
        2328.17138671875,
        370.37506103515625,
        -67.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2053271234035492,
        -0.35364648699760437,
        -0.9125650525093079
      ],
      "plane_d": -593.739013671875,
      "bbox_min": [
        1300.0,
        -94.099853515625,
        -337.6260986328125
      ],
      "bbox_max": [
        1700.0,
        -52.900146484375,
        -279.62261962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09089095890522003,
        0.9102500677108765,
        0.40395984053611755
      ],
      "plane_d": 346.6627197265625,
      "bbox_min": [
        1364.394287109375,
        -94.099853515625,
        -334.8937072753906
      ],
      "bbox_max": [
        1700.0,
        -52.900146484375,
        -279.62261962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09089066833257675,
        0.910250723361969,
        -0.4039585590362549
      ],
      "plane_d": -175.35299682617188,
      "bbox_min": [
        1364.394287109375,
        -94.099853515625,
        -332.975830078125
      ],
      "bbox_max": [
        1700.0,
        -52.900146484375,
        -279.62261962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16968359053134918,
        -0.6344022154808044,
        0.754149317741394
      ],
      "plane_d": 465.77935791015625,
      "bbox_min": [
        1698.3134765625,
        -53.11676025390625,
        -280.0020751953125
      ],
      "bbox_max": [
        1700.0,
        -52.900146484375,
        -279.62261962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.009485919959843159,
        -0.693903386592865,
        0.7200056910514832
      ],
      "plane_d": 148.4962158203125,
      "bbox_min": [
        1493.922607421875,
        -91.69747161865234,
        -315.4051513671875
      ],
      "bbox_max": [
        2032.4091796875,
        33.78660202026367,
        -200.38539123535156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09089095890522003,
        0.9102500677108765,
        0.40395984053611755
      ],
      "plane_d": 346.6627197265625,
      "bbox_min": [
        1493.922607421875,
        -91.69747161865234,
        -315.4051513671875
      ],
      "bbox_max": [
        1700.0,
        -48.81759262084961,
        -275.8174133300781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14567448198795319,
        -0.9063680768013,
        0.3965801000595093
      ],
      "plane_d": -184.70086669921875,
      "bbox_min": [
        1503.5233154296875,
        -91.3307113647461,
        -314.0714111328125
      ],
      "bbox_max": [
        2032.4091796875,
        26.284141540527344,
        -207.202392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09089095890522003,
        0.9102500677108765,
        0.40395984053611755
      ],
      "plane_d": 346.6627197265625,
      "bbox_min": [
        1503.5233154296875,
        -91.3307113647461,
        -314.0714111328125
      ],
      "bbox_max": [
        1700.0,
        -49.230224609375,
        -273.7143249511719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33120739459991455,
        0.6114946007728577,
        0.718593180179596
      ],
      "plane_d": 817.1875,
      "bbox_min": [
        1548.370849609375,
        -89.61747741699219,
        -309.007568359375
      ],
      "bbox_max": [
        2032.4091796875,
        24.250411987304688,
        -209.64840698242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.168893501162529,
        0.6387627124786377,
        0.7506378293037415
      ],
      "plane_d": 552.586669921875,
      "bbox_min": [
        1548.370849609375,
        -89.61747741699219,
        -309.007568359375
      ],
      "bbox_max": [
        2032.4091796875,
        24.250411987304688,
        -209.64840698242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19968415796756744,
        -0.11528770625591278,
        0.9730544686317444
      ],
      "plane_d": 612.635009765625,
      "bbox_min": [
        1548.370849609375,
        -89.61747741699219,
        -309.007568359375
      ],
      "bbox_max": [
        2032.4091796875,
        24.250411987304688,
        -209.64840698242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09089095890522003,
        0.9102500677108765,
        0.40395984053611755
      ],
      "plane_d": 346.6627197265625,
      "bbox_min": [
        1548.370849609375,
        -89.61747741699219,
        -309.007568359375
      ],
      "bbox_max": [
        1616.8890380859375,
        -87.0,
        -298.3226013183594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5601200461387634,
        -0.7266098856925964,
        0.3978738486766815
      ],
      "plane_d": -1030.5103759765625,
      "bbox_min": [
        2001.8140869140625,
        2.385662078857422,
        -215.73748779296875
      ],
      "bbox_max": [
        2317.76416015625,
        339.6441345214844,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3596632182598114,
        -0.09637141972780228,
        -0.9280920028686523
      ],
      "plane_d": -851.1920166015625,
      "bbox_min": [
        2276.83447265625,
        316.11859130859375,
        -74.91072845458984
      ],
      "bbox_max": [
        2317.76416015625,
        339.6441345214844,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19968415796756744,
        -0.11528770625591278,
        0.9730544686317444
      ],
      "plane_d": 612.635009765625,
      "bbox_min": [
        2001.8140869140625,
        2.385662078857422,
        -215.73748779296875
      ],
      "bbox_max": [
        2032.4091796875,
        24.250411987304688,
        -209.64840698242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32992932200431824,
        0.5578283667564392,
        0.7615602612495422
      ],
      "plane_d": 823.4234619140625,
      "bbox_min": [
        2001.8140869140625,
        2.385662078857422,
        -215.73748779296875
      ],
      "bbox_max": [
        2015.551513671875,
        9.333513259887695,
        -214.87518310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5601200461387634,
        -0.7266098856925964,
        0.3978738486766815
      ],
      "plane_d": -1030.5103759765625,
      "bbox_min": [
        2004.3768310546875,
        3.0917320251464844,
        -215.14439392089844
      ],
      "bbox_max": [
        2319.166259765625,
        337.23248291015625,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5632988214492798,
        0.7216693162918091,
        -0.40235283970832825
      ],
      "plane_d": 1080.018798828125,
      "bbox_min": [
        2278.818603515625,
        230.66043090820312,
        -99.62260437011719
      ],
      "bbox_max": [
        2301.386474609375,
        256.5,
        -83.12399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5734601020812988,
        0.7250922322273254,
        -0.38129332661628723
      ],
      "plane_d": 1104.296142578125,
      "bbox_min": [
        2293.04931640625,
        245.19473266601562,
        -86.25222778320312
      ],
      "bbox_max": [
        2301.108154296875,
        253.08055114746094,
        -83.12399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877955079078674,
        0.23788398504257202,
        -0.3939928412437439
      ],
      "plane_d": 1949.793212890625,
      "bbox_min": [
        2300.915771484375,
        252.9500732421875,
        -83.62440490722656
      ],
      "bbox_max": [
        2301.108154296875,
        253.08055114746094,
        -83.12399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.887794554233551,
        0.2378837764263153,
        0.3939950168132782
      ],
      "plane_d": 2015.6861572265625,
      "bbox_min": [
        2294.95947265625,
        252.9500732421875,
        -99.62260437011719
      ],
      "bbox_max": [
        2301.386474609375,
        256.5,
        -83.13448333740234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877955079078674,
        0.23788398504257202,
        -0.3939928412437439
      ],
      "plane_d": 1949.793212890625,
      "bbox_min": [
        2300.925537109375,
        252.9500732421875,
        -83.62440490722656
      ],
      "bbox_max": [
        2301.386474609375,
        253.9889678955078,
        -83.13448333740234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3596632182598114,
        -0.09637141972780228,
        -0.9280920028686523
      ],
      "plane_d": -851.1920166015625,
      "bbox_min": [
        2273.24853515625,
        297.40240478515625,
        -78.40807342529297
      ],
      "bbox_max": [
        2318.326904296875,
        328.7610168457031,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3614806830883026,
        0.0968584343791008,
        -0.9273349642753601
      ],
      "plane_d": 742.0272827148438,
      "bbox_min": [
        2293.80615234375,
        315.6408386230469,
        -78.40807342529297
      ],
      "bbox_max": [
        2318.326904296875,
        328.7610168457031,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7298968434333801,
        -0.5708572268486023,
        -0.3759955167770386
      ],
      "plane_d": -1522.3905029296875,
      "bbox_min": [
        2004.3768310546875,
        3.0917320251464844,
        -215.14439392089844
      ],
      "bbox_max": [
        2319.166259765625,
        328.1429748535156,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3596632182598114,
        -0.09637141972780228,
        -0.9280920028686523
      ],
      "plane_d": -851.1920166015625,
      "bbox_min": [
        2275.556640625,
        298.6343994140625,
        -66.30570983886719
      ],
      "bbox_max": [
        2304.569091796875,
        322.25311279296875,
        -60.99939727783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3614806830883026,
        0.0968584343791008,
        -0.9273349642753601
      ],
      "plane_d": 742.0272827148438,
      "bbox_min": [
        2292.657470703125,
        304.87713623046875,
        -64.55620574951172
      ],
      "bbox_max": [
        2304.728759765625,
        322.3512268066406,
        -61.64817428588867
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32992932200431824,
        0.5578283667564392,
        0.7615602612495422
      ],
      "plane_d": 823.4234619140625,
      "bbox_min": [
        2004.3768310546875,
        3.0917320251464844,
        -215.14439392089844
      ],
      "bbox_max": [
        2300.915771484375,
        253.5687255859375,
        -80.83638000488281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19968415796756744,
        -0.11528770625591278,
        0.9730544686317444
      ],
      "plane_d": 612.635009765625,
      "bbox_min": [
        2015.551513671875,
        9.333526611328125,
        -214.87518310546875
      ],
      "bbox_max": [
        2300.915771484375,
        253.5687255859375,
        -80.83638000488281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5734601020812988,
        0.7250922322273254,
        -0.38129332661628723
      ],
      "plane_d": 1104.296142578125,
      "bbox_min": [
        2282.205810546875,
        234.337646484375,
        -90.5443344116211
      ],
      "bbox_max": [
        2300.915771484375,
        253.5687255859375,
        -80.83638000488281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5632988214492798,
        0.7216693162918091,
        -0.40235283970832825
      ],
      "plane_d": 1080.018798828125,
      "bbox_min": [
        2282.205810546875,
        234.337646484375,
        -90.5443344116211
      ],
      "bbox_max": [
        2293.04931640625,
        245.19473266601562,
        -86.25222778320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2195121943950653,
        0.0,
        0.9756097793579102
      ],
      "plane_d": 655.7545166015625,
      "bbox_min": [
        1300.0,
        -89.66277313232422,
        -363.28228759765625
      ],
      "bbox_max": [
        1445.4794921875,
        -45.900146484375,
        -337.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.168893501162529,
        0.6387627124786377,
        0.7506378293037415
      ],
      "plane_d": 552.586669921875,
      "bbox_min": [
        1300.0,
        -89.66277313232422,
        -357.66583251953125
      ],
      "bbox_max": [
        1445.4794921875,
        -45.900146484375,
        -337.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08982770889997482,
        -0.9124379754066467,
        -0.39923423528671265
      ],
      "plane_d": -299.8360290527344,
      "bbox_min": [
        1300.0,
        -89.66277313232422,
        -353.6243896484375
      ],
      "bbox_max": [
        1429.8035888671875,
        -45.900146484375,
        -337.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09089095890522003,
        0.9102500677108765,
        0.40395984053611755
      ],
      "plane_d": 346.6627197265625,
      "bbox_min": [
        1415.4498291015625,
        -89.66277313232422,
        -343.6463928222656
      ],
      "bbox_max": [
        1429.8035888671875,
        -87.0,
        -337.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16968359053134918,
        -0.6344022154808044,
        0.754149317741394
      ],
      "plane_d": 465.77935791015625,
      "bbox_min": [
        1300.0,
        -78.61463165283203,
        -371.9364929199219
      ],
      "bbox_max": [
        1402.8170166015625,
        -45.900146484375,
        -353.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2195121943950653,
        0.0,
        0.9756097793579102
      ],
      "plane_d": 655.7545166015625,
      "bbox_min": [
        1300.0,
        -78.61463165283203,
        -371.9364318847656
      ],
      "bbox_max": [
        1402.8170166015625,
        -45.900146484375,
        -353.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08982798457145691,
        -0.912437379360199,
        0.3992355167865753
      ],
      "plane_d": 216.07479858398438,
      "bbox_min": [
        1300.0,
        -78.61463165283203,
        -369.62261962890625
      ],
      "bbox_max": [
        1402.8170166015625,
        -45.900146484375,
        -353.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.168893501162529,
        0.6387627124786377,
        0.7506378293037415
      ],
      "plane_d": 552.586669921875,
      "bbox_min": [
        1381.6051025390625,
        -78.61463165283203,
        -361.2872314453125
      ],
      "bbox_max": [
        1402.8170166015625,
        -75.21826171875,
        -353.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2006595879793167,
        -0.6306444406509399,
        0.7496822476387024
      ],
      "plane_d": 504.5957946777344,
      "bbox_min": [
        567.7013549804688,
        -94.099853515625,
        -379.6484069824219
      ],
      "bbox_max": [
        1415.539794921875,
        180.10397338867188,
        -330.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2195121943950653,
        0.0,
        0.9756097793579102
      ],
      "plane_d": 655.7545166015625,
      "bbox_min": [
        1300.0,
        -67.07801055908203,
        -379.6484069824219
      ],
      "bbox_max": [
        1344.5589599609375,
        -52.900146484375,
        -369.62261962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.168893501162529,
        0.6387627124786377,
        0.7506378293037415
      ],
      "plane_d": 552.586669921875,
      "bbox_min": [
        1300.0,
        -94.099853515625,
        -379.6484069824219
      ],
      "bbox_max": [
        1415.4498291015625,
        -64.818359375,
        -330.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09089066833257675,
        0.910250723361969,
        -0.4039585590362549
      ],
      "plane_d": -175.35299682617188,
      "bbox_min": [
        1300.0,
        -94.099853515625,
        -379.6484069824219
      ],
      "bbox_max": [
        1391.7713623046875,
        -64.818359375,
        -330.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2195121943950653,
        0.0,
        0.9756097793579102
      ],
      "plane_d": 655.7545166015625,
      "bbox_min": [
        1300.0,
        -75.21826171875,
        -379.6484069824219
      ],
      "bbox_max": [
        1381.6051025390625,
        -64.818359375,
        -361.2872314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08409183472394943,
        -0.9128960967063904,
        0.39943620562553406
      ],
      "plane_d": 584.697509765625,
      "bbox_min": [
        -1669.793701171875,
        353.7113342285156,
        -333.6243896484375
      ],
      "bbox_max": [
        -1470.0,
        359.099853515625,
        -301.7356872558594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.023061316460371017,
        -0.3612494468688965,
        -0.9321839809417725
      ],
      "plane_d": -202.7902374267578,
      "bbox_min": [
        -1709.6956787109375,
        154.2874298095703,
        -379.6484069824219
      ],
      "bbox_max": [
        611.3817749023438,
        359.099853515625,
        -303.8778076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08409183472394943,
        -0.9128960967063904,
        0.39943620562553406
      ],
      "plane_d": 584.697509765625,
      "bbox_min": [
        -1704.28369140625,
        342.7159423828125,
        -316.2267150878906
      ],
      "bbox_max": [
        -1586.8519287109375,
        355.94830322265625,
        -303.8778076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27925851941108704,
        0.8776695132255554,
        0.3895009160041809
      ],
      "plane_d": -142.71047973632812,
      "bbox_min": [
        200.0,
        180.10397338867188,
        -369.62261962890625
      ],
      "bbox_max": [
        567.7012939453125,
        263.0,
        -342.757568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2798520028591156,
        -0.8795349597930908,
        0.38483911752700806
      ],
      "plane_d": 459.52532958984375,
      "bbox_min": [
        200.0,
        180.10397338867188,
        -369.62261962890625
      ],
      "bbox_max": [
        567.7012939453125,
        258.3406982421875,
        -342.757568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2792586386203766,
        0.8776701092720032,
        -0.38949963450431824
      ],
      "plane_d": -418.1841735839844,
      "bbox_min": [
        200.0,
        221.38363647460938,
        -353.6243896484375
      ],
      "bbox_max": [
        459.9652404785156,
        255.900146484375,
        -342.757568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27985215187072754,
        -0.8795353770256042,
        -0.3848378360271454
      ],
      "plane_d": 187.34896850585938,
      "bbox_min": [
        372.18310546875,
        221.38363647460938,
        -353.6243896484375
      ],
      "bbox_max": [
        459.9652404785156,
        249.31431579589844,
        -344.40948486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2006595879793167,
        -0.6306444406509399,
        0.7496822476387024
      ],
      "plane_d": 504.5957946777344,
      "bbox_min": [
        200.0,
        259.25,
        -379.6484069824219
      ],
      "bbox_max": [
        313.8623046875,
        274.78173828125,
        -369.62261962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1583103984594345,
        0.6399000883102417,
        0.7519744038581848
      ],
      "plane_d": 292.1353454589844,
      "bbox_min": [
        -1657.635009765625,
        245.21697998046875,
        -355.61151123046875
      ],
      "bbox_max": [
        372.3886413574219,
        324.1795349121094,
        -315.3790283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27985215187072754,
        -0.8795353770256042,
        -0.3848378360271454
      ],
      "plane_d": 187.34896850585938,
      "bbox_min": [
        200.0,
        245.21697998046875,
        -355.61151123046875
      ],
      "bbox_max": [
        372.3886413574219,
        263.0,
        -337.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2792586386203766,
        0.8776701092720032,
        -0.38949963450431824
      ],
      "plane_d": -418.1841735839844,
      "bbox_min": [
        200.0,
        249.31431579589844,
        -355.61151123046875
      ],
      "bbox_max": [
        372.1831359863281,
        263.0,
        -337.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2798520028591156,
        -0.8795349597930908,
        0.38483911752700806
      ],
      "plane_d": 459.52532958984375,
      "bbox_min": [
        365.8841857910156,
        249.31431579589844,
        -355.61151123046875
      ],
      "bbox_max": [
        372.1831359863281,
        251.3185272216797,
        -353.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11422112584114075,
        -0.358980655670166,
        -0.9263295531272888
      ],
      "plane_d": -183.25570678710938,
      "bbox_min": [
        200.0,
        258.3406982421875,
        -379.6484069824219
      ],
      "bbox_max": [
        321.814453125,
        297.099853515625,
        -330.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2006595879793167,
        -0.6306444406509399,
        0.7496822476387024
      ],
      "plane_d": 504.5957946777344,
      "bbox_min": [
        200.0,
        258.3406982421875,
        -379.6484069824219
      ],
      "bbox_max": [
        321.814453125,
        297.099853515625,
        -369.62261962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": 379.64837646484375,
      "bbox_min": [
        200.0,
        272.97894287109375,
        -379.6484069824219
      ],
      "bbox_max": [
        238.35133361816406,
        285.181640625,
        -379.6484069824219
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}